import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface ExtractedContentSidePanelProps {
  filename: string;
  content: string;
}

const ExtractedContentSidePanel: React.FC<ExtractedContentSidePanelProps> = ({
  filename,
  content,
}) => {

  return (
    <div className="flex flex-col h-full">
      <div className="flex justify-between items-center mb-4 p-4 border-b border-gray-200 dark:border-gray-600">
        <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100">
          {filename}
        </h2>
      </div>

      <div className="p-4 flex-1 overflow-y-auto custom-scrollbar">
        <div
          className="
            prose dark:prose-invert
            bg-white dark:bg-gray-800
            px-6
            max-w-none
            text-sm leading-relaxed
          "
          style={{ fontFamily: 'Garamond, serif' }}
        >
          <ReactMarkdown
            className="prose dark:prose-invert max-w-none text-sm"
            remarkPlugins={[remarkGfm]}
          >
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default ExtractedContentSidePanel;
